import { clearDataAction, logoutAction } from './reducers';
import { AuthService, EcomService } from '../api';
import { unauthorizedApiResponseInterceptor } from '../api/interceptor';

const initialize = (store: any, setToken: (token?: string) => void) => {
  const state = store.getState();
  unauthorizedApiResponseInterceptor(() => {
    store.dispatch(logoutAction);
    store.dispatch(clearDataAction());
    setToken(undefined);
    // window.location.reload();
  }, [
    AuthService.loginUrl,
    AuthService.azureLoginUrl,
    EcomService.ecomTokenUrl,
  ]);

  setToken(state.authUser.token);
  if (state.authUser.token) {
    setToken(state.authUser.token);
    // store.dispatch(userActions.fetchProfile());
  }
};

export default initialize;
